import React from "react";
import Header from "../MerchandiseStore/Header/Header";
import Footer from "../../components/partials/FooterComponent";
import { connect } from "react-redux";

const TermsNConditions = (props) => {
  return (
    <>
      <Header totalItems={props.totalItems} />
      <div className="container mb-5">
        <div className="row">
          <div className="col-12">
            <h1 className="text-center font-weight-bold mt-4">Terms and Conditions</h1>
            <br />
            <div className="">
                <h3>Return Policy </h3>
              <p>
              You are eligible for a return/exchange, only if the item shipped is damaged/ defective/ if you have received the wrong item. 
                </p>
              <p>
                To initiate a refund, you can contact us at <a href="mailto:contact@codeium.tech">contact@codeium.tech</a> within 3 days of receiving your product. Once your refund is accepted, a return shipping label will be sent, along with detailed instructions on how and where to send your package. Kindly note, items sent back to us without first requesting a return, will not be accepted. 
              </p>
              <p>
                As we do not have a reverse pickup facility yet, you are requested to ship the product(s) back to us. Please pack the items securely to prevent any loss or damage during transit. For return-related queries (For eg. Shipping address etc) mail us at <a href="mailto:contact@codeium.tech">contact@codeium.tech</a>. Shipping charges for the same will be borne by the customer.
              </p>
              <h3>Exceptions / non-returnable items.</h3>
              <p>
                Kindly note we do not accept returns gift cards.
              </p>
              <h3>Refund Policy</h3>
              <p>
                We will send a new product if the product you have received is defective/ damaged/ if you have received the wrong item. As we do not have a reverse pickup facility yet, you are kindly requested to ship the product(s) back to us. Please pack the items securely to prevent any loss or damage during transit. For return, related queries (For eg. Shipping address, order id) mail us at <a href="mailto:contact@codeium.tech">contact@codeium.tech</a>.
              </p>
            </div>  
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    totalItems: state.cart.totalItems,
  };
};

export default connect(mapStateToProps)(TermsNConditions);
